import React from 'react';
import { useTheme } from '../../../../theme-context';
import { RULES_KEYS } from '../../../../utils/constants/rules-stats';
import Error from '../../../../shared/error';

const RulesSceleton = ({
    children,
    ruleKey,
    title,
    error,
    description,
    changedValue,
    onClickSave,
    onClickReapplyPrevious,
    onShowPrevious,
    showPrevious,
    previousValue
}: any) => {
    const { theme } = useTheme();
    return (
        <div className='rounded-xl border border-1 p-4 mb-6'>
            <div className='flex flex-col md:flex-row md:justify-between items-center mb-3'>
                <div className='mb-2'>
                    <p className='font-medium text-lg dark:text-primary-dark'>{title}</p>
                    <p className='text-sm text-primary-light dark:text-primary-dark'>{description}</p>
                </div>
                {error && <Error text={error}/>}
                <div>
                    <div
                        onClick={() => changedValue && onShowPrevious(ruleKey)}
                        className={`py-2 px-3 rounded-lg bg-[#F5F5F5] dark:bg-bgColor-darkMode dark:text-primary-dark ${changedValue ? ' cursor-pointer hover:opacity-80' : 'opacity-50 cursor-not-allowed'}`}>
                        {showPrevious ? 'Hide previous value' : 'Show previous value'}
                    </div>
                </div>
            </div>
            {showPrevious && changedValue && previousValue !== undefined && (
                <div className='bg-gray-100 dark:bg-gray-700 text-sm p-3 rounded-md mb-3'>
                    <strong className='mr-2'>Previous Value:</strong>
                    {RULES_KEYS?.[ruleKey] ? RULES_KEYS?.[ruleKey]?.find((item: any) => item?.value === previousValue)?.label || previousValue : previousValue}
                </div>
            )}
            {children}
            <div className='pt-4 border-t border-t-1 dark:border-gray-600 my-2 flex flex-col md:flex-row md:justify-end items-center'>
                <div
                    onClick={() => changedValue && onClickReapplyPrevious(ruleKey)}
                    className={`py-2 px-3 rounded-lg bg-[#F5F5F5] dark:bg-bgColor-darkMode dark:text-primary-dark flex flex-row items-center md:mr-2 mb-2 md:mb-0 ${changedValue ? ' cursor-pointer hover:opacity-80' : 'opacity-50 cursor-not-allowed'}`}
                >
                    <img src={theme === 'dark' ? '/assets/admin-tab/retry-white.svg' : '/assets/admin-tab/retry.svg'} className='object-contain w-[24px] mr-2' />
                    <p className='dark:text-primary-dark'>Re-apply previous</p>
                </div>
                <div
                    onClick={() => changedValue && onClickSave(ruleKey)}
                    className={`${changedValue ? 'bg-[#1E4380] cursor-pointer' : 'bg-[#1E438080] cursor-not-allowed'} py-2 px-3  hover:opacity-80 rounded-lg  flex flex-row items-center`}
                >
                    <img src={'/assets/admin-tab/save.svg'} className='object-contain w-[24px] mr-2' />
                    <p className='text-white'>Save Changes</p>
                </div>
            </div>
        </div>
    );
};

export default RulesSceleton